export const getKeySectionConflictMessage = (
    keyNames: string[]
): string => {
    return `Key Section assigned to ${keyNames.toString()} is different than originally planned on the budget screen. 
    Press confirm to continue and budget screen will be updated or cancel to go back.`;
};

export const getKeySectionConflictTitle = () => 'Key Section Conflict:';